/**
 * Categorias de ocupações e áreas de atuação
 * Baseado em dados do IBGE e CBO (Classificação Brasileira de Ocupações)
 */

export const occupationCategories = {
  "Beleza e Estética": [
    "Cabeleireira", "Cabeleireiro", "Barbeiro", "Barbeira",
    "Manicure", "Pedicure", "Nail Designer",
    "Lash Designer", "Designer de Sobrancelhas", "Micropigmentadora",
    "Esteticista", "Maquiadora", "Maquiador", "Visagista",
    "Depiladora", "Podóloga", "Massagista", "Massoterapeuta",
    "Consultora de Beleza", "Colorista", "Extensionista Capilar"
  ],
  
  "Comércio e Varejo": [
    "Vendedor", "Vendedora", "Atendente", "Caixa", "Balconista",
    "Promotor de Vendas", "Promotora de Vendas",
    "Representante Comercial", "Consultor de Vendas", "Consultora de Vendas",
    "Gerente de Loja", "Supervisor de Vendas", "Visual Merchandiser",
    "Comprador", "Operador de Telemarketing"
  ],
  
  "Serviços Domésticos": [
    "Diarista", "Empregada Doméstica", "Cuidador de Idosos", "Cuidadora de Idosos",
    "Babá", "Auxiliar de Limpeza", "Zelador", "Zeladora", "Porteiro",
    "Jardineiro", "Caseiro", "Cozinheira Doméstica", "Governanta"
  ],
  
  "Transporte e Entregas": [
    "Motorista de Aplicativo", "Motorista Particular", "Motorista Executivo",
    "Entregador", "Motoboy", "Caminhoneiro",
    "Motorista de Ônibus", "Taxista", "Piloto", "Comissário de Bordo"
  ],
  
  "Alimentação e Gastronomia": [
    "Chef de Cozinha", "Cozinheiro", "Cozinheira",
    "Confeiteira", "Confeiteiro", "Padeiro", "Padeira",
    "Pizzaiolo", "Sushiman", "Bartender", "Barista",
    "Garçom", "Garçonete", "Maître", "Sommelier",
    "Food Designer", "Personal Chef"
  ],
  
  "Construção e Manutenção": [
    "Pedreiro", "Eletricista", "Encanador",
    "Pintor", "Carpinteiro", "Marceneiro",
    "Serralheiro", "Soldador", "Gesseiro",
    "Azulejista", "Vidraceiro", "Mestre de Obras",
    "Técnico em Ar Condicionado", "Técnico em Refrigeração"
  ],
  
  "Moda e Costura": [
    "Costureira", "Estilista", "Designer de Moda",
    "Modelista", "Alfaiate", "Bordadeira",
    "Sapateiro", "Artesã", "Artesão",
    "Personal Stylist", "Consultora de Imagem", "Consultor de Imagem"
  ],
  
  "Influência Digital": [
    "Influenciador Digital", "Influenciadora Digital",
    "Content Creator", "Criador de Conteúdo",
    "Streamer", "Youtuber", "Podcaster",
    "Social Media Manager", "Community Manager"
  ],
  
  "Saúde": [
    "Medicina", "Médico", "Médica",
    "Enfermagem", "Enfermeiro", "Enfermeira",
    "Odontologia", "Dentista",
    "Psicologia", "Psicólogo", "Psicóloga",
    "Fisioterapia", "Fisioterapeuta",
    "Nutrição", "Nutricionista",
    "Farmácia", "Farmacêutico", "Farmacêutica",
    "Veterinária", "Veterinário",
    "Fonoaudiologia", "Fonoaudiólogo",
    "Terapia Ocupacional", "Terapeuta Ocupacional",
    "Biomedicina", "Biomédico"
  ],
  
  "Tecnologia": [
    "Desenvolvimento de Software", "Desenvolvedor", "Desenvolvedora",
    "Ciência da Computação", "Engenharia de Software",
    "Sistemas de Informação", "Ciência de Dados", "Data Scientist",
    "Inteligência Artificial", "Cibersegurança",
    "Redes e Infraestrutura", "UX/UI Design", "DevOps",
    "Analista de Sistemas", "Programador", "Programadora"
  ],
  
  "Educação": [
    "Ensino Fundamental", "Ensino Médio", "Ensino Superior",
    "Pedagogia", "Professor", "Professora",
    "Educação Física", "Coordenação Pedagógica",
    "Psicopedagogia", "Educação Especial",
    "Cursos Técnicos", "Educação a Distância"
  ],
  
  "Jurídico": [
    "Advocacia Civil", "Advocacia Criminal", "Advocacia Trabalhista",
    "Advocacia Empresarial", "Advogado", "Advogada",
    "Magistratura", "Juiz", "Juíza",
    "Ministério Público", "Procuradoria",
    "Consultoria Jurídica", "Compliance", "Direito Digital"
  ],
  
  "Engenharia": [
    "Engenharia Civil", "Engenharia Mecânica", "Engenharia Elétrica",
    "Engenharia de Produção", "Engenharia Química",
    "Engenharia Ambiental", "Engenharia de Alimentos",
    "Engenharia Naval", "Engenharia Aeronáutica",
    "Engenharia de Segurança", "Engenheiro", "Engenheira"
  ],
  
  "Administração e Negócios": [
    "Administração", "Administrador", "Administradora",
    "Gestão de Empresas", "Recursos Humanos",
    "Marketing", "Vendas", "Logística",
    "Comércio Exterior", "Empreendedorismo",
    "Consultoria Empresarial", "Gestão de Projetos"
  ],
  
  "Finanças": [
    "Contabilidade", "Contador", "Contadora",
    "Controladoria", "Auditoria", "Auditor",
    "Análise Financeira", "Analista Financeiro",
    "Investimentos", "Banking", "Seguros",
    "Planejamento Financeiro", "Mercado de Capitais", "Economia"
  ],
  
  "Comunicação e Marketing": [
    "Jornalismo", "Jornalista",
    "Publicidade e Propaganda",
    "Relações Públicas", "Marketing Digital",
    "Comunicação Social", "Produção Audiovisual",
    "Redação", "Redator", "Redatora",
    "Social Media", "Branding", "Comunicação Corporativa"
  ],
  
  "Design e Artes": [
    "Design Gráfico", "Designer Gráfico",
    "Design de Interiores", "Arquitetura", "Arquiteto", "Arquiteta",
    "Artes Visuais", "Fotografia", "Fotógrafo", "Fotógrafa",
    "Ilustração", "Ilustrador", "Ilustradora",
    "Design de Moda", "Design de Produto",
    "Animação", "Direção de Arte"
  ],
  
  "Hospitalidade e Turismo": [
    "Hotelaria", "Turismo", "Gastronomia",
    "Eventos", "Entretenimento", "Recreação",
    "Guia de Turismo", "Gestão Hoteleira",
    "Culinária", "Sommelier"
  ],
  
  "Esportes": [
    "Educação Física", "Personal Trainer",
    "Fisioterapia Esportiva", "Nutrição Esportiva",
    "Gestão Esportiva", "Treinamento Esportivo",
    "Recreação", "Esportes Profissionais",
    "Preparação Física", "Reabilitação"
  ],
  
  "Agricultura": [
    "Agronomia", "Engenharia Ambiental",
    "Biologia", "Gestão Ambiental",
    "Agricultura Sustentável", "Pecuária",
    "Silvicultura", "Recursos Naturais",
    "Conservação", "Ecologia"
  ],
  
  "Indústria": [
    "Engenharia de Produção", "Qualidade",
    "Segurança do Trabalho", "Manutenção Industrial",
    "Automação", "Manufatura", "Gestão da Produção",
    "Lean Manufacturing", "Six Sigma", "Supply Chain"
  ],
  
  "Serviços Públicos": [
    "Administração Pública", "Segurança Pública",
    "Defesa", "Bombeiros", "Polícia",
    "Fiscalização", "Serviços Sociais",
    "Saúde Pública", "Educação Pública", "Justiça"
  ],
  
  "Logística": [
    "Logística", "Transporte Rodoviário",
    "Transporte Aéreo", "Transporte Marítimo",
    "Supply Chain", "Distribuição", "Armazenagem",
    "Gestão de Frotas", "Comércio Exterior",
    "Portos e Aeroportos"
  ],
  
  "Situação Profissional": [
    "Empresário", "Empresária", "Empreendedor", "Empreendedora",
    "Investidor", "Investidora",
    "Consultor Independente", "Consultora Independente",
    "Freelancer", "Autônomo", "Autônoma",
    "Profissional Liberal", "Aposentado", "Aposentada",
    "Em transição de carreira", "Desenvolvendo novo projeto",
    "Explorando oportunidades", "Período sabático",
    "Estudante", "Pesquisador", "Pesquisadora"
  ]
};

/**
 * Opções especiais que sempre aparecem na lista
 */
export const specialOccupationOptions = [
  "Outros"
];

/**
 * Type para categorias de ocupação
 */
export type OccupationCategories = typeof occupationCategories;
